import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'


const PrivacyPolicy = () => {
    const nextTextStyle = {
        fontSize: 'clamp(1rem, 1.3vw, 1.5rem)',
        lineHeight: 1.5,
        color: '#ffffff',
        marginBottom: '15px'
    };
    const mailto = {
        color: '#0fafb7',

    };
    return (
        <div>
            <Header />

            <div className="main-container privacypolicy">
                <h2 style={{ textAlign: "center", marginBottom: "40px" }}>
                    Privacy Policy
                </h2>
                <p style={{ textAlign: "left" }}>At Code Buddy’s, we are committed to protecting the privacy and confidentiality of our users. This Privacy Policy explains how we collect, use, and safeguard the information provided to us when you use our services or interact with our website.
                </p>
                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Information We Collect:</p>
                <p
                    style={nextTextStyle}
                >Personal Information: We may collect personal information such as your name, email address, contact details, and other relevant information necessary for providing our services, communicating with you, and fulfilling your requests.</p>
                <p
                    style={nextTextStyle}
                >Usage Data: We may collect non-personal information about your interactions with our website, including IP addresses, browser type, device information, and other statistical data. This information helps us improve our services, analyze trends, and enhance user experience.</p>
                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Use of Information:</p>
                <p
                    style={nextTextStyle}
                >Service Delivery: We use the information collected to provide our services, communicate with you, and fulfill your requests or inquiries.</p>
                <p
                    style={nextTextStyle}
                >Improving Services: We may analyze non-personal information to understand user preferences, trends, and patterns. This helps us enhance our services, optimize user experience, and develop new features.</p>
                <p
                    style={nextTextStyle}
                >Communication: We may use your contact information to send you relevant updates, newsletters, or promotional materials. You have the option to unsubscribe from these communications at any time.</p>
                <p
                    style={nextTextStyle}
                >Legal Compliance: We may use and disclose information as required by law or to enforce our legal rights and protect the rights, safety, and security of our users, partners, or the public.</p>

                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Information Sharing:</p>
                <p
                    style={nextTextStyle}
                >Third-Party Service Providers: We may engage trusted third-party service providers who assist us in delivering our services and fulfilling our obligations to you. These providers are obligated to protect your information and are prohibited from using it for any other purpose.</p>
                <p
                    style={nextTextStyle}
                >Legal Requirements: We may disclose your information if required to do so by law, regulation, or legal process, or in response to valid requests by public authorities.</p>
                <p
                    style={nextTextStyle}
                >Business Transfers: If there are changes to our business, such as a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction. We will ensure that the recipient of the information agrees to maintain the same level of privacy protection.</p>

                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Data Security:</p>
                <p
                    style={nextTextStyle}
                >We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>
                <p
                    style={nextTextStyle}
                >While we strive to protect your information, no method of transmission or storage is completely secure. We cannot guarantee the absolute security of your data, and you share your information at your own risk.</p>

                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Children’s Privacy:</p>
                <p
                    style={nextTextStyle}
                >Our services are not intended for individuals under the age of 16. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child without parental consent, we will take appropriate steps to remove that information.</p>
                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Changes to the Privacy Policy:</p>
                <p
                    style={nextTextStyle}
                >We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the revised policy on our website or through other means of communication.</p>
                <p
                    style={nextTextStyle}
                >We encourage you to review this Privacy Policy regularly to stay informed about how we collect, use, and protect your information.
                </p>
                <p
                    className="label-text" style={{ color: "#0fafb7" }}
                >Contact Us:
                </p>
                <p
                    style={nextTextStyle}
                >If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at  <a href="mailto:info@codebuddys.in" style={mailto}>info@codebuddys.in</a>
                </p>
                <p
                    style={nextTextStyle}
                >This Privacy Policy was last updated on 18th July 2023.
                </p>
            </div>
            <Footer /></div>
    )
}

export default PrivacyPolicy